import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useMemo, useState } from 'react';
export const CurrentUserContext = createContext({
    currentUser: null,
    updateCurrentUser: () => {
        throw new Error('updateCurrentUser is not implemented');
    },
});
export const useCurrentUserContext = () => useContext(CurrentUserContext);
export const CurrentUserProvider = ({ children, currentUser: initialCurrentUser = null, }) => {
    const [currentUser, setCurrentUser] = useState(() => initialCurrentUser);
    const value = useMemo(() => ({
        currentUser,
        updateCurrentUser: (user) => setCurrentUser((prev) => {
            // If no previous user we're on PO so we can't have a user, return null
            if (!prev) {
                return null;
            }
            return Object.assign(Object.assign({}, prev), user);
        }),
    }), [currentUser]);
    return (_jsx(CurrentUserContext.Provider, { value: value, children: children }));
};
//# sourceMappingURL=CurrentUserContext.js.map